export interface UpdateTrackStatusDto {
  statusId: number;
  formData: FormData;
}

export enum FieldLevel {
  Property = "Property",
  PropertyPrice = "PropertyPrice",
  propertyRental = "propertyRental",
  PropertyFinishing = "PropertyFinishing",
  PropertyHospitality = "PropertyHospitality",
  Track = "Track",
  Document = "Document",
  Custom = "Custom",
  Amenity = "Amenity",
}

export enum FieldType {
  String = "String",
  Number = "Number",
  Boolean = "Boolean",
  Date = "Date",
  DateTime = "DateTime",
  Time = "Time",
  Dynamic = "Dynamic",
  // this is UI only and used in the backend as isDropDown
  Dropdown = "Dropdown",
}

export interface PropertyFieldForm {
  isRequired: boolean;
  propertyField: { id: number; name: string };
}

export interface FieldDropdown {
  id: number;
  uid: string;
  label: string | null;
  value: string | null;
}

export type FieldDropdownInput = {
  id?: number;
  uid?: string;
  label: string | null;
  value: string | null;
};

export interface TrackStatusFormField {
  id: number;
  uid: string;
  name: string;
  label: string | null;
  isDropDown: boolean | null;
  fieldLevel: FieldLevel | null;
  fieldType: FieldType | null;
  maxValue?: number | null;
  minValue?: number | null;
  maxDate?: string | null;
  minDate?: string | null;
  minDateTime?: string | null;
  maxDateTime?: string | null;
  minTime?: string | null;
  maxTime?: string | null;
  dynamicFormUrl?: string | null;
  dynamicFormLabel?: string | null;
  dynamicFormValue?: string | null;
  dynamicFormPath?: string | null;
  isPhone?: boolean | null;
  isEmail?: boolean | null;
  fieldDropdowns?: FieldDropdown[] | null;
  isRequired?: boolean | null;
  createdAt: Date;
  updatedAt: Date;
}
